import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from '../../styles/styles.css';

import { Img as Component } from './img';
import type { IDeps, TProps } from './models';

export const Img = createWidget<IDeps, TProps>({
    styles,
})(Component);
